import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const useVaultEntries = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['vault', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('vault_entries')
        .select('id, created_by, is_shared, name, encrypted_data, created_at')
        .eq('household_id', household.id)
        .order('created_at', { ascending: false })
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  const createEntry = async ({ name, encrypted_data, is_shared }) => {
    const { error } = await supabase.from('vault_entries').insert({
      name, encrypted_data, is_shared,
      household_id: household.id,
      created_by:   user.id,
    })
    if (error) throw error
    inv()
  }

  const deleteEntry = async (id) => {
    const { error } = await supabase.from('vault_entries').delete().eq('id', id)
    if (error) throw error
    inv()
  }

  return { ...query, createEntry, deleteEntry }
}
